import { type AuthInfos } from "../models/auth-infos"
import { wizedService } from "./wized.service";

class WebFlowService {
  onLogout() {
    // console.log("Webflow::Logout")
    window.location.reload()
  }

  async onLogin(infos: AuthInfos) {
    if (!infos.userAirTableId || !infos.userEmail) { console.warn("missing infos in ", infos); return }

    await wizedService.onLogin(infos)
  }
}

export const webFlowService = new WebFlowService()
